import React, { FC } from 'react';
import { NavLink } from 'react-router-dom';
import { staticConfig } from '../../config/static';
interface ITabProps {
    href?: string;
    className?: string;
}

export const Tab: FC<ITabProps> = ({ children, className, href }) => (
    <li className={className}>
        {!staticConfig.isclassicunavailable ? (
            <a href={href}>{children}</a>
        ) : (
            <NavLink
                style={(isActive) => ({
                    ...(isActive ? styles.isActive : styles.notactive),
                })}
                to={href}
            >
                {children}
            </NavLink>
        )}
    </li>
);

const styles = {
    isActive: {
        backgroundColor: '#fff',
        borderTop: '6px solid #bb1d2c',
        height: '60px',
        color: 'rgba(0, 0, 0, 0.9)',
    },
    notactive: {
        color: '#fff',
    },
};
